export default "__VITE_ASSET__4lnDmho7__"